import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ConfigActions } from './config.action';
import { ConfigInterface } from './config.interface';
import { ConfigService } from './config.service';

@Injectable()
export class ConfigEffects {
  private readonly configService = inject(ConfigService);
  private readonly actions$ = inject(Actions);

  getConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ConfigActions.getConfig),
      switchMap(() => {
        // Note : For new settings static we doesn't need to load config file, already load into environment.ts
        if (window['NAConfig'] && !window['NAConfig'].isProdDomain) {
          return this.configService.loadConfig();
        }
        return of(window['NAConfig']);
      }),
      map((config: ConfigInterface) => ConfigActions.getConfigSuccess(config)),
    ),
  );
}
